<template>
  <div class="card flex flex-col bg-white  box-content  pb-4 rounded-3xl shadow-md">
    <router-link :to="{ name: 'entry', params: { id: this.entry.id } }">
        <div class="w-full h-96 lg:h-80 flex bg-cover bg-full  rounded-3xl"
             :style="{'background-image': 'url(' + entry.data.image.url  + ')'}">
        <span class="flex  self-end text-sm font-semibold rounded py-1 rounded-3xl px-3  bg-fuchsia-500 text-white" href="#">{{ entry.data.speaker[0].text }}</span>
      </div>
    </router-link>
    <div class="flex flex-col justify-between  px-5 pt-4 pb-2 h-48 lg:h-50">
      <div>
        <prismic-rich-text class="mb-2 font-display text-xl leading-tight font-bold line-clamp-3" :field="entry.data.title" />
        <p class=" text-sm leading-tight block text-gray-500 font-xs line-clamp-3">{{entry.data.description[0].text}}</p>
      </div>
      <router-link class="flex  text-gray-300 hover:text-fuchsia-500 truncate " v-on:click="doTravel" :to="{ name: 'entry', params: { id: this.entry.id } }">
        Zobacz więcej
      </router-link>
    </div>
    </div>
    </template>

    <script>
    export default {
        name: 'Card',
        data() {
            return {}
        },
        methods:{
            doTravel: function(){
                this.$router.push({ name: 'entry', params: { id: this.entry.id } })
            }
        },
        components:{
        },
        props: {
            entry: {}
        }
    }
</script>

    <style scoped>
    pre{
        font-size: x-small;
        height: 10vh;
        overflow:scroll;
    }
</style>
